import Page from "./page";
import { useTranslation } from "react-i18next";
import qrcode from '../../assets/software/qrcodeOrange.png';
import Pic1 from '../../assets/software/self/1.png';
import Pic2 from '../../assets/software/self/2.png';
import logo1 from '../../assets/software/self/logo1.png';
import logo2 from '../../assets/software/self/logo2.png';
import selfPic from '../../assets/software/self/self.png';
function Selfhelp() {
  let { t } = useTranslation();

  const datas = [
    {
      pic: Pic1,
      logo: logo1,
      title: t("selfType.reportTitle"),
      infos: [
        t("selfType.reportInfo1"),
        t("selfType.reportInfo2"),
        t("selfType.reportInfo3"),
        t("selfType.reportInfo4"),
      ],
      bgcolor: "rgb(255,248,240)",
    },
    {
      pic: Pic2,
      logo: logo2,
      title: t("selfType.goodsTitle"),
      infos: [
        t("selfType.goodsInfo1"),
        t("selfType.goodsInfo2"),
        t("selfType.goodsInfo3"),
      ],
    }
  ]
  return (
    <Page
      {...{
        title: t("selfType.title"),
        content: t("selfType.info"),
        pic: selfPic,
        bgColor: "rgba(255, 142, 43, 1)",
        linearGradient: 'linear-gradient(161.37deg, rgba(255, 106, 0, 1) 0%, rgba(255, 153, 64, 1) 100%)',
        downInfo: {
          bgColor: "#ff8122",
          qrBgColor: '#ffebd1',
          qrcode: qrcode,
          showMac: false,
          showWin: false,
          urlName: 'pharmacy_orderbyself'
        },
        bodyDatas: datas,
        textColor: '#fff'
      }}
    />
  );
}

export default Selfhelp;

